// extracted by mini-css-extract-plugin
export default {"root":"RenewalsConfigurationTab_root__RCcCw","itemIcon":"RenewalsConfigurationTab_itemIcon__zVKKx"};